import cn from 'clsx'

const clx = cn

export default clx
